import Basic3 from './Basic3'
export default Basic3
